<template>
  <div class="third">
    <div class="third-formOne">
      <div class="formOne-btn">
        <div class="btn-left">
          <span class="left-back-icon" @click="changeComponent">
            <i class="el-icon-arrow-left"></i>
            <span class="left-back-title">返回</span>
          </span>
          <span class="left-back-shu">
            <span class="left-back-shu-content"></span>
          </span>
          <span class="left-back-content">{{isDisable?"编辑版本":"发布更新"}}</span>
        </div>
        <div class="btn-right">
          <el-button class="btn-two" type="default" @click="reset">重置</el-button>
          <el-button class="btn-two" type="primary" @click="commit">保存</el-button>
        </div>
      </div>
      <el-form
        :model="otherForm"
        :rules="rules"
        ref="otherForm"
        label-width="86px"
        :show-message="false"
        @validate="validateValue"
      >
        <div class="formOne-forms">
          <div class="forms-one" style="margin-top: 57px;">
            <div class="one-title">
              <div class="title-left">
                <span class="left-icon">
                  <i class="el-icon-s-operation"></i>
                </span>
                <span class="left-content">基本信息</span>
              </div>
            </div>
            <div class="one-list">
              <div class="list-one-line">
                <el-form-item label="客户端类型" prop="appType">
                  <el-radio-group v-model="otherForm.appType" :disabled="isDisable">
                    <el-radio :label="2">安卓</el-radio>
                    <el-radio :label="1">iOS</el-radio>
                  </el-radio-group>
                </el-form-item>
                <el-form-item label="版本号" prop="version" style="height: 40px;">
                  <el-input
                    :maxlength="30"
                    class="list-input"
                    v-model.trim="otherForm.version"
                    placeholder="请输入"
                  ></el-input>
                  <div class="el-form-item__error">
                    该版本号将展示给用户，请输入例如V1.0.1
                  </div>
                </el-form-item>
                <el-form-item label="构建号" prop="versionCode">
                  <el-input
                    class="list-input"
                    v-model.trim="otherForm.versionCode"
                    placeholder="请输入正整数"
                    :maxlength='30'
                  ></el-input>
                  <div style="color: #AEAEB4;font-size: 12px;">
                    若高于用户本地客户端的构建号，则用户本地需更新
                  </div>
                </el-form-item>
                <el-form-item label="更新方式" prop="updateType">
                  <el-radio-group v-model="otherForm.updateType">
                    <el-radio :label="2">推荐更新</el-radio>
                    <el-radio :label="1">强制更新</el-radio>
                  </el-radio-group>
                </el-form-item>
                <el-form-item label="上传文件" prop="fileUrl" v-if="otherForm.appType === 2">
                  <el-upload
                    class="upload-demo"
                    action="/api/blade-platform/file/upload"
                    :on-remove="handleRemove"
                    :multiple="false"
                    :before-upload="beforeAvatarUpload"
                    :on-success="handleAvatarSuccess"
                    :on-error="handleAvatarError"
                    :on-exceed="handleExceed"
                    :limit="1"
                    :data="{ fileType: 3 }"
                    :file-list="fileList">
                    <el-button size="small" type="primary">点击上传</el-button>
                    <div slot="tip" class="el-upload__tip">100M以内，支持扩展名：.apk</div>
                  </el-upload>
                </el-form-item>
                <el-form-item label="跳转地址" prop="updateUrl"  v-if="otherForm.appType === 1">
                  <el-input
                    class="list-input"
                    v-model.trim="otherForm.updateUrl"
                    placeholder="请输入"
                  ></el-input>
                </el-form-item>
                <el-form-item label="更新说明" prop="remark">
                  <el-input
                    class="list-input"
                    type="textarea"
                    :rows="4"
                    v-model="otherForm.remark"
                    placeholder="请输入"
                    :maxlength='200'
                  ></el-input>
                </el-form-item>
              </div>
            </div>
          </div>

          <div class="forms-one">
            <div class="one-title">
              <div class="title-left">
                <span class="left-icon">
                  <i class="el-icon-s-operation"></i>
                </span>
                <span class="left-content">发布信息</span>
              </div>
            </div>
            <div class="one-list">
              <div class="list-one-line">
                <el-form-item label="发布方式" prop="isEffect">
                  <el-radio-group v-model="otherForm.isEffect">
                    <el-radio :label="1">即时发布</el-radio>
                    <el-radio :label="0">定时发布</el-radio>
                  </el-radio-group>
                </el-form-item>
                <div v-if="otherForm.isEffect === 0">
                  <el-form-item label="定时发布时间" prop="releaseTime">
                    <el-date-picker
                      v-model="otherForm.releaseTime"
                      type="datetime"
                      align="right"
                      format="yyyy-MM-dd HH:mm"
                      value-format="yyyy-MM-dd HH:mm:ss"
                      placeholder="选择日期时间">
                    </el-date-picker>
                  </el-form-item>
                </div>
              </div>
            </div>
          </div>

        </div>
      </el-form>
    </div>

  </div>
</template>

<script>
import { getStore, setStore } from "@/utils/store";
export default {
  data() {
    var validate = (rule, value, callback) => {
      const select = new Date(value).getTime()
      const now = new Date().getTime()
      if (select < now) {
        return callback(new Error('发布时间不能小于当前时间'));
      }
      callback();
    }
    return {
      rules: {
        remark: [{ required: true, message: "请输入更新说明", trigger: "blur" }],
        appType: [{ required: true, message: "请选择服务名称", trigger: "change" }],
        version: [{ required: true, message: "请输入版本号", trigger: "blur" }],
        versionCode: [
          { required: true, message: "请输入构建号",trigger: "blur" },
          { type: "string", pattern: /^[+]{0,1}(\d+)$/,  message: "请输入正整数", trigger: "blur" }
        ],
        updateType: [{ required: true, message: "请选择更新方式", trigger: "change" }],
        fileUrl: [{ required: true, message: "请上传文件", trigger: "change" }],
        updateUrl: [{ required: true, message: "请输入跳转地址", trigger: "blur" }],
        isEffect: [{ required: true, message: "请选择发布方式", trigger: "change" }],
        releaseTime: [{ validator: validate, trigger: "change" }],
      },
      otherForm: {
        appType: 2, // 客户端
        updateType: 2,
        version: '',
        versionCode: '',
        fileUrl: '',
        updateUrl: '', //IOS为跳转地址 安卓为文件下载地址
        remark: '',
        isEffect: '',
        releaseTime: '',
      },
      countNum: 1, //用于显示第一个错误
      fileList: [],
    }
  },
  methods: {
    getSessonValue(name) {
      return getStore({
        name: name,
        type: "session",
      });
    },
    // 改变index页面的component的值
    changeComponent() {
      this.$emit("changeComponent", "homePage");
    },
    reset() {
      // return Object.assign(
      //   this.otherForm,
      //   cloneDeep(this.$options.data().otherForm)
      // );
      const homePageRowData = this.getSessonValue('homePageRowData')
      if (homePageRowData) {
        this.otherForm= {
        appType: Number(homePageRowData.appType), // 客户端
        updateType: Number(homePageRowData.updateType),//更新方式
        version: homePageRowData.version,//版本号
        versionCode: String(homePageRowData.versionCode),//构建号
        fileUrl: homePageRowData.updateUrl,
        updateUrl: homePageRowData.updateUrl, //IOS为跳转地址 安卓为文件下载地址
        remark: homePageRowData.remark,
        isEffect: homePageRowData.isEffect,//发布方式
        releaseTime: homePageRowData.releaseTime,//发布时间
        }
        this.fileList=[{
            name:homePageRowData.updateUrl.substring(homePageRowData.updateUrl.lastIndexOf("/")+1),
            url:homePageRowData.updateUrl
        }]
        console.log(this.fileList)
      } else {
        this.fileList=[]
        this. otherForm= {
            appType: 2, // 客户端
            updateType: 2,
            version: '',
            versionCode: '',
            fileUrl: '',
            updateUrl: '', //IOS为跳转地址 安卓为文件下载地址
            remark: '',
            isEffect: '',
            releaseTime: '',
        }
    }

    },
    // 验证
    validateValue(prop, msgStatus, validateMessage) {
      if (!this.countNum && !msgStatus) {
        this.countNum += 1;
        if (validateMessage) {
          this.$message.error(validateMessage);
        }
      }
    },
    // 提交表单
    commit() {
      console.log(this.otherForm)
      this.countNum = 0;
      this.$nextTick(() => {
        this.$refs.otherForm.validate(valid => {
          console.log("valid", valid);
          if (valid) {
            this.saveAppVersion();
          } else {
            return false;
          }
        });
      });
    },
    saveAppVersion() {
      let { otherForm } = this;
      delete otherForm.fileUrl
      const homePageRowData = this.getSessonValue('homePageRowData')
      this.$store.dispatch('saveAppVersion', {
        id: homePageRowData?homePageRowData.id:'',
        ...otherForm
      }).then((res) => {
        if (res.data.status === 1000) {
          this.changeComponent();
           this.$message.success('发布成功！');
        } else {
          this.$message.error(res.data.msg);
        }
      })
    },
    handleRemove(file, fileList) {
      // console.log(file, fileList);
      this.otherForm.fileUrl = '';
    },
    handleExceed(files, fileList) {
      this.$message.warning('只能上传一个文件，请先删除再上传。');
    },
    beforeAvatarUpload(file) {
      console.log('上传文档类型', file)
      const reg = /\.apk$/g
      // const isJPG = ((file.type === 'application/vnd.android.package-archive') || ());
      const isJPG = reg.test(file.name)
      // console.log('reg.test(file.name)', reg.test(file.name))
      const isLt2M = file.size / 1024 / 1024 < 100;
      console.log(isJPG)
      if (!isJPG) {
        this.$message.error('上传文件格式不正确!');
      }
      if (!isLt2M) {
        this.$message.error('上传文件大小不能超过 100MB!');
      }
      return isJPG && isLt2M;
    },
    // 上传失败
    handleAvatarError(err, file, fileList) {
        console.log(this.fileList);
        console.log(fileList)
      this.fileList = []
      this.$message.error(err)
    },
    handleAvatarSuccess(res, file) {
        console.log(res, '上传结果')
        console.log(this.fileList, '上传结果')
        if (res.status === 0) {
            const [ufile] =  res.data;
            // console.log(this.fileList)
            this.otherForm.updateUrl = ufile.oUrl;
            this.otherForm.fileUrl = ufile.oUrl;
        } else {
            this.fileList = []
            this.$message.error(res.msg)
        }
    },
  },
  created(){
    const homePageRowData = this.getSessonValue('homePageRowData')
    console.log(homePageRowData)
    if (homePageRowData) {
        this.otherForm= {
        appType: Number(homePageRowData.appType), // 客户端
        updateType: Number(homePageRowData.updateType),//更新方式
        version: homePageRowData.version,//版本号
        versionCode: String(homePageRowData.versionCode),//构建号
        fileUrl: homePageRowData.updateUrl,
        updateUrl: homePageRowData.updateUrl, //IOS为跳转地址 安卓为文件下载地址
        remark: homePageRowData.remark,
        isEffect: homePageRowData.isEffect,//发布方式
        releaseTime: homePageRowData.releaseTime,//发布时间
      }
      this.fileList=[{
          name:homePageRowData.updateUrl.substring(homePageRowData.updateUrl.lastIndexOf("/")+1),
          url:homePageRowData.updateUrl
      }]
      console.log(this.fileList)
    }
  },
  computed: {
      isDisable() {
            const homePageRowData = this.getSessonValue('homePageRowData')
            if (homePageRowData) {
                return true
            }else {
                return false
            }
        }
  }
}
</script>

<style lang="scss">
.el-upload__tip {
  color: #AEAEB4;
}
</style>
